<template>
  <div class="home">
    <div class="wrapper-content registerHeader marginhide">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2 v-if="isEdit">{{ $t('message.EditProfile') }}</h2>
          <h2 v-else>{{ $t('message.RegisterProfile') }}</h2>
        </div>
      </div>
      <div class="profile-edit-photo" v-if="isEdit">
        <div class="round-profile">
          <img src="../assets/images/download.png" alt="user-img" />
        </div>
        <!-- <my-upload
          @crop-success="cropSuccess"
          v-model="show"
          img-format="png"
          langType="en"
          noCircle
          noSquare
          :width="414"
          :height="260"
        ></my-upload>
        <img
          src="../assets/images/plus.png"
          class="upload-imageinline"
          alt="upload-images"
          v-on:click="toggleShow"
        />-->
      </div>
      <div class="addmoney newaddress">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2">
              <div class="add-newaddresss panel">
                <div class="input-animation">
                  <form @submit.prevent="saveDetails">
                    <div class="input-field">
                      <input type="text" id="name" v-model="name" />
                      <label for="name">{{ $t('message.Name') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!name && submitStatus"
                    >{{ $t('message.NameValidation') }}</div>

                    <div class="input-field">
                      <input type="text" id="email" v-model="email" />
                      <label for="email">{{ $t('message.Email') }}</label>
                    </div>
                    <div class="error" v-if="!$v.email.email">{{ $t('message.ValidEmail') }}</div>
                    <div
                      class="error"
                      v-if="!email && submitStatus"
                    >{{ $t('message.EmailValidation') }}</div>

                    <div class="input-field">
                      <input type="text" id="house" v-model="houseNo" />
                      <label for="house">{{ $t('message.HouseNumber') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!houseNo && submitStatus"
                    >{{ $t('message.HouseNumberValidation') }}</div>

                    <div class="input-field" v-if="!isEdit">
                      <input type="text" id="Street" v-model="street" />
                      <label for="street">{{ $t('message.Street') }}</label>
                    </div>

                    <div class="input-field">
                      <input type="text" id="city" v-model="city" />
                      <label for="city">{{ $t('message.City') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!city && submitStatus"
                    >{{ $t('message.CityValidation') }}</div>

                    <div class="input-field">
                      <input type="text" id="state" v-model="state" />
                      <label for="state">{{ $t('message.State') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!state && submitStatus"
                    >{{ $t('message.StateValidation') }}</div>

                    <div class="input-field">
                      <input type="text" id="land" v-model="landmark" />
                      <label for="land">{{ $t('message.Landmark') }}</label>
                    </div>

                    <div class="input-field">
                      <label>{{ $t('message.Nickname') }}</label>
                      <br />
                      <br />
                      <b-form-radio-group
                        id="btn-radios-2"
                        v-model="selectedTitle"
                        :options="options"
                        buttons
                        button-variant="outline-dark"
                        size="lg"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                    </div>
                    <div
                      class="error"
                      v-if="!selectedTitle && submitStatus"
                    >{{ $t('message.NicknameValidation') }}</div>

                    <button
                      class="submit-btn"
                      type="submit"
                      v-on:click="saveDetails"
                    >{{ $t('message.Proceed') }}</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { registerProfile, getProfileDetails } from "./../services/api";
import VueGeolocation from "vue-browser-geolocation";
import Vuelidate from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import myUpload from "vue-image-crop-upload";

Vue.use(Vuelidate);

const axios = require("axios");
Vue.use(VueGeolocation);
export default {
  name: "home",
  components: {
    myUpload
  },
  validations: {
    name: {
      required
    },

    state: {
      required
    },
    city: {
      required
    },
    houseNo: {
      required
    },
    email: {
      email,
      required
    },
    selectedTitle: {
      required
    }
  },
  data() {
    return {
      show: false,
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      lat: "",
      long: "",
      address: "",
      image: "",
      addressTitle: "",
      key: "AIzaSyBmS9QQWofTpIbYDpWebbUP9lhbBBW5raA",
      name: "",
      email: "",
      street: "",
      locality: "",
      state: "",
      city: "",
      zipCode: "",
      houseNo: "",
      landmark: "",
      center: {
        lat: "",
        lng: ""
      },
      file: [],
      markers: [],
      places: [],
      currentPlace: null,
      options: [
        { text: "Home", value: "home" },
        { text: "Work", value: "work" },
        { text: "Others", value: "other" }
      ],
      selectedTitle: "",
      submitStatus: false,
      isEdit: window.location.href.includes("edit-profile")
    };
  },
  created() {
    if (this.isEdit) {
      this.getProfile();
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(img) {
      console.log(img);
      this.image = img;
    },

    getProfile() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: localStorage.getItem("vendorId")
      };
      // this.isLoading = true;
      getProfileDetails(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            var a = result.data.profile.houseNo.split(",");
            console.log(result);
            if (a.length > 1) {
              this.street = a[1];
            }
            this.profile = result.data;
            this.profile_details = result.data.profile;
            this.name = result.data.profile.name;
            this.email = result.data.profile.email_id;
            this.houseNo = a[0];
            this.image = this.imageBaseUrl + result.data.profile.image;
            this.state = result.data.profile.state;
            this.city = result.data.profile.city;
            this.zipcode = result.data.profile.zipcode;
            this.locality = result.data.profile.locality;
            this.landmark = result.data.profile.landMark;
            this.selectedTitle = result.data.profile.title;
            this.center.lat = result.data.profile.latitude;
            this.center.lng = result.data.profile.longitude;

            this.isLoading = false;
          } else if (
            (result.data.successCode === 0 &&
              result.data.messageCode === 1053) ||
            result.data.messageCode == 201
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          // this.isLoading = false;
          return;
        });
    },
    saveDetails() {
      if (this.$v.$invalid) {
        // this.submitStatus = "ERROR";
        this.submitStatus = true;
      } else {
        var hno;
        if (this.street) {
          hno = this.houseNo + "," + this.street;
        } else {
          hno = this.houseNo;
        }
        var img = this.image.split("base64,");
        var adGiven = {
          name: this.name,
          email: this.email,
          address: hno,
          landMark: this.landmark,
          state: this.state,
          title: this.selectedTitle,
          city: this.city,
          lat: this.center.lat,
          long: this.center.lng,
          image: img[1]
        };
        localStorage.setItem("address", JSON.stringify(adGiven));
        if (window.location.href.includes("edit-profile")) {
          this.$router.push("edit-location");
        } else {
          this.$router.push("location");
        }
      }
    }
  }
};
</script>
<style lang="scss">
@import "../assets/css/custom.scss";
</style>